module.exports = __webpack_public_path__ + "static/media/r-15176517-1587684963-2782-300x272.3a46469b.jpg";